/* eslint-disable @typescript-eslint/semi */
/* eslint-disable eqeqeq */
/* eslint-disable @typescript-eslint/type-annotation-spacing */
/* eslint-disable @typescript-eslint/no-inferrable-types */
/* eslint-disable prefer-const */
/* eslint-disable no-trailing-spaces */
import { Component, OnInit } from '@angular/core';
import {
  Form,
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';
import { LoadingController, AlertController, NavController } from '@ionic/angular';
import { UserApiService } from '../services/user-api.service';
import { Router } from '@angular/router';
// interface ForgotPasswordData {
//   email: String;
//   phone: String;
// }
@Component({
  selector: 'app-forgot-password',
  templateUrl: './forgot-password.page.html',
  styleUrls: ['./forgot-password.page.scss'],
})
export class ForgotPasswordPage implements OnInit {



  usingPhone: boolean=true;
  email:any;
  phone:any;

  constructor(private fb: FormBuilder,  
    private loginApi: UserApiService,
    private alertCtrl: AlertController,
    private loadingCtrl: LoadingController,
    private router: Router,
    private navCtrl: NavController  
) { 
  }

  ngOnInit() {
  }

  forgotUsing(){
    if( this.usingPhone==true){
      this.usingPhone=false;
    }
    else{
      this.usingPhone=true
    }
    
  }

  async forgetEmail() {
    if(this.email == '' || this.email == null || this.email == undefined){
      const alert = await this.alertCtrl.create({
        header: 'Enter Email',
        buttons: ['OK'],
      });
      await alert.present();
      return;
    }
    const loading = await this.loadingCtrl.create({
      message: 'Please Wait ...',
    });
    await loading.present();
    let cleanEmail=String(this.email);

    this.loginApi.customerForgotPassword(cleanEmail.trim())
      .subscribe(
        async (response) => {
          loading.dismiss();
          if (response.status) {
            this.router.navigate(['login']);
            const alert = await this.alertCtrl.create({
              header: 'Successfully Forgot Password',
              message: response.description,
              buttons: ['OK'],
            });
            await alert.present();
            loading.dismiss();
          } else {
            console.log(' login failed'); 
          }
        },
        async (error) => {
          console.log(error);
          const alert = await this.alertCtrl.create({
            header: 'Error',
            message: 'No response from server.Check internet connection.',
            buttons: ['OK'],
          });
          await alert.present();
          loading.dismiss();
        }
      );
  }

  close() {
    this.navCtrl.back(); 
    // this.router.navigateByUrl('/login', { replaceUrl: true });
  }

}
